import { Middleware } from 'redux';
import { Action } from 'typescript-fsa';
import { AppState } from '@app/react/reducer';
import { openDialogAction, closeDialogAction } from './action';

type DialogInfo = {
    key: string;
    autoClose: boolean;
    userData: any;
};

export const dialogMiddleware: Middleware<Record<string, unknown>, AppState> = () => (next) => (
    action: Action<any>,
) => {
    const info: DialogInfo | undefined = action?.meta?.dialogInfo;
    if (info === undefined) {
        return next(action);
    }

    const { key, autoClose = false, userData } = info;

    const payload = {
        key,
        okHandler: () => {
            if (action.meta?.dialogInfo) {
                delete action.meta.dialogInfo;
            }
            next(action);
            if (autoClose) {
                next(closeDialogAction({ key }));
            }
        },
        cancelHandler: () => {
            next(closeDialogAction({ key }));
        },
        userData,
    };

    return next(openDialogAction(payload));
};
